import {
    layer1Offset,
    layer1Size,
    layer2Offset,
    layer2Size,
    layer3Offset,
    layer3Size,
} from '@/features/ui/inputs/components/Switch/parts/Knob/parts/SimulatedShadow/constants'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

const SimulatedShadow: FC = () => {
    return (
        <View style={styles.shadowContainer}>
            <View
                style={[
                    styles.shadowLayer,
                    styles.shadowLayer1,
                    layer1Size,
                    layer1Offset,
                    { borderRadius: layer1Size.width / 2 },
                ]}
            />
            <View
                style={[
                    styles.shadowLayer,
                    styles.shadowLayer2,
                    layer2Size,
                    layer2Offset,
                    { borderRadius: layer2Size.width / 2 },
                ]}
            />
            <View
                style={[
                    styles.shadowLayer,
                    styles.shadowLayer3,
                    layer3Size,
                    layer3Offset,
                    { borderRadius: layer3Size.width / 2 },
                ]}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    shadowContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'visible',
        zIndex: -1,
    },
    shadowLayer: {
        position: 'absolute',
    },
    shadowLayer1: {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        opacity: 0.08,
        elevation: 5,
    },
    shadowLayer2: {
        backgroundColor: 'rgba(0, 0, 0, 0.14)',
        opacity: 0.2,
        elevation: 10,
    },
    shadowLayer3: {
        backgroundColor: 'rgba(0, 0, 0, 0.20)',
        opacity: 0.4,
        elevation: 20,
    },
})

export default SimulatedShadow
